import React, { FC } from 'react'
import { useParams } from 'react-router-dom'

import { FormAdminContainer } from 'components'
import { ArtistEditAction, ArtistFormContainer } from 'modules/Artists/components'
import { useArtist } from '../serviceHooks/useArtist'
import { TRouterParams } from 'shared/types'

const ArtistEditContainer: FC = () => {
  const { id } = useParams<TRouterParams>()
  const { artist, products } = useArtist(id)

  return (
    <FormAdminContainer
      backLink="/admin/artists"
      actions={id && artist ? <ArtistEditAction id={id} artist={artist} products={products} /> : undefined}
    >
      {
        artist && (
          <ArtistFormContainer products={products} artist={artist} />
        )
      }
    </FormAdminContainer>
  )
}

export default ArtistEditContainer
